const PORTAL_ENTITY_ID = 'entityId'

export const CASHFLOW_REPORTING = (entityId = `:${PORTAL_ENTITY_ID}`) => ({
  relative: 'cashflow',
  path: `/orgs/${entityId}/reports/cashflow`,
})
